var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.29 87.9c-24.974-6.49-33.005-13.2-33.005-23.65 0-11.99 11.112-20.35 29.705-20.35 19.584 0 26.845 9.35 27.505 23.1h24.314c-.77-18.92-12.322-36.3-35.316-41.91V1H79.487v23.76C58.143 29.38 40.98 43.24 40.98 64.47c0 25.41 21.014 38.06 51.71 45.43 27.504 6.6 33.005 16.28 33.005 26.51 0 7.59-5.39 19.69-29.705 19.69-22.664 0-31.575-10.12-32.786-23.1H39c1.32 24.09 19.363 37.62 40.487 42.13V199h33.006v-23.65C133.947 171.28 151 158.85 151 136.3c0-31.24-26.735-41.91-51.71-48.4Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "assets/media/money.77cf0db5.svg";
export { ForwardRef as ReactComponent };